import React from 'react';

import { StyledCard } from './styles';

const PanelCard: React.FC = ({ children }) => {
  return <StyledCard>{children}</StyledCard>;
};

export default PanelCard;
